module.exports = __webpack_public_path__ + "img/password.25991088.svg";